import { useEffect, useState } from 'react';
import Joi from 'joi';
import { Link, Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Trans, useTranslation } from 'react-i18next';
import useForm from '../../../hooks/useForm';
import { renderInput, renderButton } from '../../common/renderUtils';
import FormHeader from '../../common/FormHeader';
import userService from '../../../services/userService';
import ResetRequested from './components/ResetRequested';
import auth from '../../../services/authService';
import { setDocTitle } from '../../../utils/utilities';

const ResetPassword = () => {
  const { t } = useTranslation();
  const [submitted, setSubmitted] = useState(false);

  const schema = {
    email: Joi.string().email({ tlds: { allow: false } }).required().label('Email'),
  };

  const initialData = { email: '' };

  const { data, errors, handleChange, handleSubmit, isFormValid } = useForm(initialData, schema);

  useEffect(() => {
    setDocTitle(t('auth.resetPassword'));
  }, [t]);

  const doSubmit = async () => {
    try {
      await userService.resetPassword(data.email);
      setSubmitted(true);
    } catch (ex) {
      // We no longer warn the user if the email does not exist
      // if (ex.response && ex.response.status === 404) {
      //   setErrors({
      //     email: 'There is no account associated with this email.',
      //   });
      // }

      if (ex.response && ex.response.status === 500) {
        toast.error(t('auth.resetFailed'));
      }

      setSubmitted(false);
    }
  };

  // If there is an existing user, redirect to home
  if (auth.getCurrentUser()) return <Redirect to="/" />;

  const { email } = data;

  switch (submitted) {
    case true:
      return <ResetRequested email={email} />;
    default:
      return (
        <div className="auth-page">
          <form onSubmit={(e) => handleSubmit(e, doSubmit)} className="form-reset">
            <FormHeader title={t('auth.resetInstructions')} />
            {renderInput('email', t('auth.emailAddress'), 'email', data, errors, handleChange)}
            {renderButton(t('auth.resetPassword'), isFormValid())}
            <div className="mg-text-center mg-mt-2">
              <Trans i18nKey="auth.orSignIn" components={{ go: <Link to="/signin" /> }} />
            </div>
          </form>
        </div>
      );
  }
};

export default ResetPassword;
